<template>
  <div
    class="open_banner_padding container grid grid-cols-12 gap-[20px] pb-[20px] pt-[36px] lg:pb-[40px] lg:pt-[20px]"
  >
    <CommonLeftMenu
      class="col-span-3 hidden max-w-[290px] lg:col-span-2 xl:block"
    />
    <div class="col-span-full flex max-w-[1530px] flex-col xl:col-span-10">
      <MainPagePinnedElementsBlock
        v-if="pinned?.data?.value?.length"
        :data="pinnedMapped"
        class="mb-[80px] lg:aspect-[1530/642]"
      />

      <MainPageDates />

      <NuxtLink
        v-if="false"
        class="mb-20"
        to="https://igrovoy.rt.ru/dp?utm_source=rvio&utm_medium=banner&utm_campaign=dpmt"
        target="_blank"
        external
      >
        <div class="overflow-hidden rounded-xl">
          <img
            v-lazy-load
            src="/imgs/banners/diktan_pobed.jpg"
            alt="Диктант Победы"
            class="w-full transition-transform duration-300 ease-out hover:scale-[1.04]"
          />
        </div>
      </NuxtLink>

      <!-- <NuxtLink class="mb-20" to="/test_po_istorii_otechestva">
        <div class="overflow-hidden rounded-xl">
          <img
            v-lazy-load
            src="/bighistory/main-banner.jpg"
            alt="Тест по истории"
            class="transition-transform duration-300 ease-out hover:scale-[1.04]"
          />
        </div>
      </NuxtLink> -->

      <MainPageCollectionsBlock
        v-if="thematicCollections.length"
        :data="thematicCollections"
        title="Тематические подборки"
        class="mb-[80px]"
      />

      <MainPageSpecialProjectsHistory class="mb-[80px]" />

      <MainPagePartnersBlock :data="partners" class="mb-[80px]" />

      <MainPageNewsBlock
        v-if="news?.data?.value?.data?.length"
        :data="news.data?.value?.data"
        class="mb-[80px]"
      />

      <MainPageVoinaNaVostoke
        v-if="voinaNaVostoke?.length"
        :data="voinaNaVostoke"
        class="mb-[80px]"
      />

      <MainPageGamesBlock
        v-if="games?.data?.value?.data?.length"
        :data="games.data?.value?.data"
        class="mb-[80px]"
      />

      <MainPageTestBlock v-if="false" class="mb-[80px]" />

      <MainPagePresentationBlock v-if="false" class="mb-[80px]" />

      <MainPageMyHistoryArticlesBlock class="mb-[80px]" />

      <MainPageRandomVideosBlock
        v-if="false && videoMaterials?.data?.value?.length"
        :data="videoMaterials.data.value"
        class="mb-[80px]"
      />

      <!-- <MainPageSummerArticlesBlock class="mb-[80px]" /> -->

      <MainPageThisDayBlock
        v-if="
          thisDayInHistory?.data?.value &&
          Object.values(thisDayInHistory?.data?.value)?.length
        "
        :data="thisDayInHistory?.data?.value"
        class="mb-[80px]"
      />

      <MainPagePopularArticlesBlock class="mb-[80px]" />

      <ClientOnly>
        <MainPageThemeOfTheWeekBlock
          :data="projects"
          class="mb-[80px]"
          title="Проекты"
        />
      </ClientOnly>

      <MainPageScienceBlock class="mb-[80px]" />

      <MainPageRvioProjectsBlock class="mb-[40px]" />

      <MainPageMilitaryLibraryBlock class="mb-[80px]" />

      <MainPageFilmsBlock
        v-if="filmsMaterials?.data?.value?.length"
        :data="filmsMaterials?.data?.value"
        class="mb-[80px]"
      />

      <MainPageAudioBlock class="mb-[80px]" />

      <MainPageKonchalovskyBlock v-if="false" />

      <MainPageUnknownWarBlock
        v-if="unknownWarReverse?.length"
        :data="unknownWarReverse"
        class="mb-[80px]"
      />

      <MainPagePeopleOfHistory
        v-if="peopleOfHistory?.length"
        :data="peopleOfHistory"
      />
      <!-- <Transition name="fade-modal">
        <ModalsModalNewYear />
      </Transition> -->
    </div>
  </div>
</template>

<script setup>
import partners from '@/assets/data/our-partners';
import projects from '@/assets/data/special-projects/projects';

definePageMeta({
  layout: 'marginless',
});
const { videoMaterials } = useVideoMaterials();
const { films: unknownWar } = useFilms({
  filters: { category: 21 },
  per_page: 20,
});
const { films: peopleOfHistoryData } = useFilms({
  filters: { category: 5 },
  per_page: 20,
});
const { lectures: voinaNaVostokeData } = useVideoLectures({
  filters: { category: 29 },
  per_page: 20,
});
const { filmsMaterials } = useFilmsMaterials();
const { news } = useNews({ per_page: 4, isMainPage: true });
const { pinned } = usePinnedElements();
const { thematicCollections: thematic } = useThematicCollection({
  staleTime: 0,
});
const { thisDayInHistory } = useThisDayInHistory();
const { games } = useGame();
const pinnedMapped = computed(() =>
  pinned?.data?.value?.map((item) => {
    return [
      item.pinnedElement,
      ...(item.chields?.map((child) => child.pinnedElement) ?? []),
    ];
  }),
);

const peopleOfHistory = computed(() => {
  return peopleOfHistoryData?.data?.value?.data;
});

const voinaNaVostoke = computed(() => {
  if (!voinaNaVostokeData?.data?.value?.data) return [];
  return [...voinaNaVostokeData.data.value.data].reverse();
});

const unknownWarReverse = computed(() => {
  if (!unknownWar?.data?.value?.data) return [];
  return [...unknownWar.data.value.data].reverse();
});

const thematicCollections = computed(() => {
  if (!thematic?.data?.value?.length) return [];
  return thematic.data.value;
});

useHead({
  title: 'Федеральный портал Истории России',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'История Российской Федерации | Освещаем все вехи российской истории. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
});
</script>
